// Libraries
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import CheckIcon from '@mui/icons-material/Check';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import { AActionButton, AButtonBaseProps } from '../../common/buttons';

export interface AOkButtonProps extends Omit<AButtonBaseProps, 'children'> {
    children?: ReactNode;
}

export default function AOkButton(props: AOkButtonProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);
    const { children, ...actionButtonProps } = props;
    const children2 = children ? children : t('AnelmaGeneral:1054');

    return <AActionButton {...actionButtonProps} children={children2} icon={<CheckIcon />} />;
}
